import { HouseLineIcon, IconProps, UserIcon } from '@phosphor-icons/react';
import React from 'react';

import { close } from 'ionicons/icons';

import { useUserForm } from '../../../hooks/User/useUserForm';
import { Address as AddressType, User } from '../../../types/User/types';
import Alert from '../../UI/Alert';
import FormHeader from '../../UI/FormHeader';
import Navigation from '../../UI/Navigation';
import StepWrapper from '../../UI/StepWrapper';
import Address from '../Address';
import Personal from '../Personal';
import './UserForm.scss';
import { UserFormProps } from './types';

const iconLocalProps: IconProps = { weight: 'fill' };

export const getSteps = (userData?: User, addressData?: AddressType) => [
  {
    icon: <UserIcon {...iconLocalProps} />,
    title: 'Datos personales',
    subtitle: userData
      ? 'Editá tu información personal'
      : 'Completá tu información personal',
  },
  {
    icon: <HouseLineIcon {...iconLocalProps} />,
    title: 'Domicilio',
    subtitle: addressData
      ? 'Editá los datos de tu dirección'
      : 'Completá con los datos de tu dirección',
  },
];

const UserForm: React.FC<UserFormProps> = ({
  userData,
  addressData,
  closeModal,
  isRequired = false,
  submitMode = 'auto',
}) => {
  const steps = getSteps(userData, addressData);

  const {
    // Estado
    user,
    setUser,
    address,
    setAddress,
    isInitialized,
    isSubmissionComplete,

    // Submit
    onSubmit,
    isSubmitting,

    // Provincias y localidades
    localidades,
    isFetchingLocalidades,
    handleProvinciaChange,

    // Navegación
    currentStep,
    totalSteps,
    isFirst,
    next,
    back,

    // Alertas
    alertState,
    hideAlert,
  } = useUserForm({
    userData,
    addressData,
    closeModal,
    isRequired,
    submitMode,
    totalSteps: steps.length,
  });

  const showCloseButton = !isRequired || !isFirst;

  return (
    <div className="user-form-page">
      <Navigation
        startIcon={isFirst ? close : undefined}
        onBack={isFirst ? closeModal : back}
        showBackButton={showCloseButton}
        currentStep={currentStep}
        totalSteps={totalSteps}
        isCompleted={isSubmissionComplete}
      />

      <div className="ion-padding-horizontal">
        <FormHeader {...steps[currentStep - 1]} />

        <StepWrapper show={currentStep === 1}>
          <Personal
            user={user}
            setUser={setUser}
            goForward={next}
            isLoading={!isInitialized}
          />
        </StepWrapper>

        <StepWrapper show={currentStep === 2}>
          <Address
            address={address}
            setAddress={setAddress}
            onSubmit={onSubmit}
            submitButtonText={
              submitMode === 'direct'
                ? 'Guardar datos'
                : userData
                  ? 'Enviar solicitud de cambio'
                  : 'Registrarme'
            }
            isSubmitting={isSubmitting}
            onProvinciaChange={handleProvinciaChange}
            localidades={localidades}
            isFetchingLocalidades={isFetchingLocalidades}
            isLoading={!isInitialized}
          />
        </StepWrapper>
      </div>

      <Alert
        isOpen={alertState.isOpen}
        header={alertState.header}
        message={alertState.message}
        buttons={alertState.buttons}
        onDidDismiss={hideAlert}
      />
    </div>
  );
};

export default UserForm;
